// AVISO-SIN-SERVICIOS: textos del plan aprobado por Jesús (27 Oct 2026).
export const TEXTOS_DOCTORES = {
  serviciosConSofi: "Este profesional no tiene servicios. Sofi no lo ofrecerá ni se le pueden agendar citas hasta que agregues al menos uno.",
  serviciosSinSofi: "Este profesional no tiene servicios. No se le pueden agendar citas hasta que agregues al menos uno.",
  horarioConSofi: "Este profesional no tiene horario de atención. Sofi no lo ofrecerá ni se le pueden agendar citas hasta que configures su horario.",
  horarioSinSofi: "Este profesional no tiene horario de atención. No se le pueden agendar citas hasta que configures su horario.",
};

// Recibe exclusivamente el profesional guardado devuelto por GET /doctors.
export function avisoAgenda(doctor, sinSofi) {
  if (doctor.servicios_activos === 0) {
    return TEXTOS_DOCTORES[sinSofi ? "serviciosSinSofi" : "serviciosConSofi"];
  }
  if (doctor.servicios_activos > 0 && doctor.availability?.length === 0) {
    return TEXTOS_DOCTORES[sinSofi ? "horarioSinSofi" : "horarioConSofi"];
  }
  return null;
}
